import {ApiRes} from '@type/api'
import {apiGet} from '@api/api'
import {IConfirmResponse} from '@api/auths/register/Register'

export const apiSendPasswordResetCode = async (email: string): Promise<ApiRes<IConfirmResponse>> => {
    return await apiGet(`password/reset/${email}`)
}
